<template>
  <div>
    <h2>{{ $t('playHistory.title') }}</h2>
    <div class="accordion" v-if="!loading">
      <div class="accordion-item" v-for="(inning, index) in sortedScore" :key="index">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button" type="button" data-bs-toggle="collapse"
            :data-bs-target="'#collapse-' + index" aria-expanded="true" aria-controls="collapseOne">
            Inning {{ inning.inning }}
          </button>
        </h2>
        <div :id="'collapse-' + index" class="accordion-collapse collapse" aria-labelledby="headingOne"
          data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <div class="radio-group">
              <template v-for="(play, key) in inning.play" :key="key" class="btn btn-bb5-yellow m-0 p-2 my-2 w-100">
                <input class="form-check-input" type="radio" :id="'radioPlay-' + inning.inning  + '-' + key" name="playOptions" v-model="selectedPlay" :value="`${inning.inning}-${key}`"/>
                <label class="form-check-label" 
                :for="'radioPlay-' + inning.inning + '-' + key">
                  {{ play.team }} {{ play.action !== 'position' ? play.action : '' }} {{
                  playPosition(play) }}
                </label>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 d-flex gap-3">
      <button @click="confirmSelection" class="btn btn-bb5-yellow w-100 m-0 p-2 my-2">{{ $t('confirm') }}
      </button>
      <button @click="closeModal" class="btn btn-bb5-black w-100 m-0 p-2 my-2">{{ $t('cancel') }}
      </button>
    </div>
  </div>
</template>


<script>
import core from "@/mixins/Core";
import { mapGetters } from "vuex";
import localStorageService from "@/services/localStorageService";

export default {
  data() {
    return {
      loading: true,
      score: {},
      sortedScore: {},
      usePlayerNames: false,
      selectedPlay: null
    };
  },
  mixins: [core],
  async created() {
    const gameId = localStorage.getItem('currentgame');
    this.score = await this.getData('getScore', { id: gameId });
    const inning = this.score.score.inning;
    this.sortedScore = [...inning].sort((a, b) => b.inning - a.inning);
    this.loading = false;
    this.usePlayerNames = localStorageService.get('useNames') === 'false' ? false : true;
  },
  computed: {
    ...mapGetters(['getPlayerById']),
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    confirmSelection() {
      if (this.selectedPlay) {
        this.$emit('prevplay', this.selectedPlay );
      } else {
        alert(this.$t('playHistory.alert'));
      }
    },
    getPlayer(playerId) {
      const player = this.getPlayerById(playerId);
      if (!player) {
        console.error("Player not found for ID:", player);
        return '';
      }
      const identifier = this.usePlayerNames ? player.name : '#' + player.number;
      return player ? identifier : '';
    },
    playPosition(play) {
      if (play.action !== 'position') return '';
      // console.log('playposition', play);
      const position = play.positions[play.offenceTeam].find(position => position.id === play.playerId);
      if (!position) return '';
      if (position.curPos === 0) return this.$t('playHistory.playScored');
      return this.$t('playHistory.playAdvanced', { base: position.curPos });
    },
    reverseInningObject(obj) {
      return Object.keys(obj)
        .sort((a, b) => b - a) // numerisch absteigend sortieren
        .reduce((acc, key) => {
          acc[key] = obj[key];
          return acc;
        }, {});
    }
  }
};
</script>

<style scoped>
.radio-group {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  width: 100%
}

.radio-group label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  position: relative;
  transition: all 0.3s ease;
  text-align: center;
  user-select: none;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group label::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) scale(0);
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  transition: transform 0.2s ease;
}

.radio-group input[type="radio"]:checked+label {
  background-color: var(--bb5-yellow);
  color: #000;
  border-color: var(--bb5-yellow);
}

.radio-group input[type="radio"]:checked+label::after {
  transform: translateY(-50%) scale(1);
}

.radio-group label:hover {
  background-color: #ddd;
  border-color: #aaa;
}
</style>
